module.exports = __webpack_public_path__ + "static/media/home.made.lovely-IG-4.ea49a1b2.PNG";